export const dataTestRoot = "aviv.CDP";
